import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Divider, Spinner } from '@chakra-ui/react';
import { AiOutlineGoogle } from 'react-icons/ai';
import { IconContext } from 'react-icons';

import { Service } from './Service';
import { MySubmitButton } from './MyCustomComponents';
import { useServiceQuery } from '../hooks/useServiceQuery';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { resetCategoryToUpdate } from '../redux/slices/categoryToUpdateSlice';
import { GOOGLE_AUTH_URL } from '../constants';
import styles from './styles/service-list.module.scss';

export const ServiceList: React.FC = () => {
  // react router
  const navigate = useNavigate();

  // i18n
  const { t } = useTranslation();

  // UI states
  const filteredCategory = useAppSelector(
    (state) => state.selectedCategory.selectedCategory
  );
  const hasCookies = useAppSelector((state) => state.auth.hasCookies);
  const dispatch = useAppDispatch();

  // server states
  const { data, isLoading } = useServiceQuery(hasCookies);

  if (!hasCookies) {
    return (
      <div className={styles.loginWrapper}>
        <IconContext.Provider
          value={{
            style: { width: '22px', height: '22px' },
          }}
        >
          <AiOutlineGoogle />
        </IconContext.Provider>

        <a href={GOOGLE_AUTH_URL} className={styles.loginLink}>
          {t('require-login')}
        </a>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={styles.spinnerWrapper}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {data!
        .filter(
          (service) =>
            service.category === filteredCategory ||
            filteredCategory === 'All Services'
        )
        .map((service) => (
          <div key={service.id}>
            <Service {...service} />
            <Divider margin="12px auto" />
          </div>
        ))}

      <div className={styles.btn}>
        <MySubmitButton
          mt="10px"
          onClick={() => {
            dispatch(resetCategoryToUpdate());
            navigate('/add');
          }}
        >
          {t('new')}
        </MySubmitButton>
      </div>
    </div>
  );
};
